module.exports = __webpack_public_path__ + "img/accessExecutionsIconGrey.99ed19a6.svg";